// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2DsZy","range":"MonthRangeSwitch_range__1aN0I","disabled":"MonthRangeSwitch_disabled__2qInj"};